"use client";
import { Get } from "@/axios/AxiosFunctions";
import PostCardWrapper from "@/components/Core/PostCard";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import Skeleton from "@/components/Skeleton";
import { BaseURL } from "@/config/apiUrl";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import classes from "./RequestEditDetails.module.css";
import RequestEditTable from "./RequestEditTable";

const LOADING_STATES = {
  GET_REQUEST_EDIT_DETAILS: "get_request_edit_details",
};

export default function RequestEditDetails() {
  const { access_token } = useSelector((state) => state?.authReducer);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(null);

  // fetch request edit details
  const fetchRequestEditDetails = async () => {
    const url = BaseURL(`admin/posts/find/${id}`);
    setLoading(LOADING_STATES.GET_REQUEST_EDIT_DETAILS);
    const response = await Get(url, access_token);
    if (response) {
      setData(response?.data);
    }
    setLoading(null);
  };

  useEffect(() => {
    fetchRequestEditDetails();
  }, [id]);

  return (
    <SideBarSkeleton>
      <div className={classes.mainWrapper}>
        {loading == LOADING_STATES.GET_REQUEST_EDIT_DETAILS ? (
          <Skeleton width="100%" height="400px" />
        ) : (
          <>
            <PostCardWrapper post={data} />
            <RequestEditTable />
          </>
        )}
      </div>
    </SideBarSkeleton>
  );
}
